import * as React from "react";
import type { SVGProps } from "react";

interface TimeoutProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Timeout = ({ cancelled = false, ...props }: TimeoutProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.5 1)">
        <ellipse cx={9.75} cy={12.93} fill="#FFF" rx={8.09} ry={8.14} />
        <path
          fill="#000"
          fillRule="nonzero"
          stroke="#FFF"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="M10.99-.38A1.32 1.32 0 0 1 12.3.8c0 .47-.13.82-.35 1.07-.24.28-.58.44-.96.44l-.38.52a9.88 9.88 0 0 1 8.77 9.74 9.88 9.88 0 0 1-9.88 9.8 9.88 9.88 0 0 1-9.88-9.8A9.88 9.88 0 0 1 8.4 2.83V2.3c-.74 0-1.07-.15-1.31-.39a1.37 1.37 0 0 1 0-1.9c.23-.24.56-.4.93-.4H11ZM9.5 4.97a7.67 7.67 0 0 0-7.66 7.6 7.67 7.67 0 0 0 13.08 5.38 7.55 7.55 0 0 0 0-10.75A7.67 7.67 0 0 0 9.5 4.97Z"
        />
      </g>
      <path
        fill="#007BBD"
        fillRule="nonzero"
        d="M12 7.36c.41 0 .75.34.75.75v4.14H18c.38 0 .7.28.74.65l.01.1c0 .41-.34.75-.75.75h-6a.75.75 0 0 1-.75-.75V8.11c0-.41.34-.75.75-.75"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Timeout;
